import { QuotaType } from '@bpinternal/const'
import { QUOTA_TYPE_USER_FACING_PROPERTIES_MAP } from '../features/usage/constants'
import { Link } from '../elements'
import { showConfirmationPrompt, DialogClose } from '@bpinternal/ui-kit-next'

//TODO: This could use some refinement, but it's a good start
export function showUpsellDialog({ quota, workspaceId }: { quota: QuotaType; workspaceId: string }) {
  return showConfirmationPrompt(
    <p>
      You have reached your {QUOTA_TYPE_USER_FACING_PROPERTIES_MAP[quota].name} quota. Please{' '}
      <DialogClose asChild>
        <Link to="/workspaces/$workspaceId/billing" params={{ workspaceId }}>
          upgrade your plan
        </Link>
      </DialogClose>{' '}
      or add an{' '}
      <DialogClose asChild>
        <Link to="/workspaces/$workspaceId/billing" params={{ workspaceId }}>
          add-on
        </Link>
      </DialogClose>{' '}
      to continue using this feature.
    </p>,
    {
      title: 'Upgrade your plan',
      cancelLabel: 'Not now',
      confirmLabel: 'Upgrade',
    }
  )
}
